import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import { debounce } from 'lodash';
import { DateIcon } from '../Icon';

const useStyles = makeStyles(() => ({
  datepicker: ({ height, width }) => ({
    '& .MuiInputBase-root': {
      borderRadius: '0.5rem',
      backgroundColor: '#fff',
      borderColor: '#e4e7eb',
      paddingLeft: '0.3rem',
      height,
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.919rem',
      letterSpacing: '0',
      color: '#2e4469',
      fontWeight: '500',
      marginLeft: '-0.3rem',
      width: '8.5rem',
      paddingRight: '0',
    },
    '&.MuiFormControl-root': {
      width,
    },
  }),
  Picon: ({ iconColor }) => ({
    width: '1.125rem',
    height: '1.25rem',
    color: iconColor,
  }),
}));

// strictCompareDates = true 的时候，maxDate跟minDate的校验精准到时分，否则只校验到日
const CustomDateTimePicker = ({
  value = moment(),
  onChange = () => {},
  variant = 'inline',
  format = 'DD-MM-YYYY HH:mm',
  maxDate = moment().year(2100),
  minDate = moment().year(1900),
  maxDateMessage = 'Start date cannot be later than end date',
  minDateMessage = 'Start date and end date cannot be over 3 days.',
  strictCompareDates = true,
  iconColor = '#2e4469',
  height = '3.5rem',
  width = '100%',
  datepicker = false,
  ...rest
}) => {
  const classes = useStyles({ iconColor, height, width });
  const [internalValue, setInternalValue] = useState(value);

  // 防抖函數
  const debouncedUpdate = useRef(
    debounce(async (inputValue) => {
      onChange(inputValue);
    }, 1000)
  ).current;

  // 清除副作用
  useEffect(() => {
    return () => {
      debouncedUpdate.cancel();
    };
  }, [debouncedUpdate]);

  const handleDatetimePickerInput = (time) => {
    setInternalValue(time);
    debouncedUpdate(time);
  };

  const Picker = datepicker ? KeyboardDatePicker : KeyboardDateTimePicker;

  return (
    <Picker
      autoOk
      className={classes.datepicker}
      keyboardIcon={<DateIcon className={classes.Picon} />}
      value={internalValue}
      onChange={handleDatetimePickerInput}
      variant={variant}
      format={format}
      inputVariant="outlined"
      InputAdornmentProps={{ position: 'start' }}
      placeholder="StartDate"
      maxDate={maxDate}
      maxDateMessage={maxDateMessage}
      // minDate={endDate?.clone?.()?.subtract?.(3, 'days')}
      minDate={minDate}
      strictCompareDates={strictCompareDates}
      minDateMessage={minDateMessage}
      {...rest}
    />
  );
};

export default CustomDateTimePicker;
